import { ChartState, ChartType } from './types';

export interface IChart {
  id: string;
  type: ChartType;
  state: ChartState;
  updatedAt: string;
  from?: string | null;
  to?: string | null;
}

class Chart {
  public readonly id: string;
  public readonly type: ChartType;
  public readonly state: ChartState;
  public readonly updatedAt: string;
  public readonly from?: string | null;
  public readonly to?: string | null;

  constructor({
    id,
    type,
    state,
    updatedAt,
    from,
    to,
  }: {
    id: string;
    type: ChartType;
    state: ChartState;
    updatedAt: string;
    from?: string | null;
    to?: string | null;
  }) {
    this.id = id;
    this.type = type;
    this.state = state;
    this.updatedAt = updatedAt;
    this.from = from;
    this.to = to;
  }

  public toJSON = () => ({
    id: this.id,
    type: this.type,
    state: this.state,
    updatedAt: this.updatedAt,
    from: this.from,
    to: this.to,
  });

  public static fromJSON = (json: IChart): Chart => {
    const { id, type, state, updatedAt, from, to } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof type !== 'string') throw new Error('.type must be a string');
    if (typeof state !== 'string') throw new Error('.state must be a string');
    if (typeof updatedAt !== 'string') throw new Error('.updatedAt must be a string');
    if (typeof from !== 'string' && from !== null) throw new Error('.from must be a string');
    if (typeof to !== 'string' && to !== null) throw new Error('.to must be a string');

    return new Chart({
      id,
      type,
      state,
      updatedAt,
      from,
      to,
    });
  };
}

export default Chart;
